import { DefaultButton } from '@fluentui/react';
import { useCustomInput } from '../../common/custom-hooks/useCustomInput';
import PlanillaDigitalForm from './PlanillaDigitalForm';
import { EventoXPlanilla } from '../../system/EventoXPlanilla/EventoXPlanilla';
import { useContainerStyle } from '../../common/custom-hooks/useStyles';

interface IPlanillaDigitalUndo {
  form: PlanillaDigitalForm;
  archivoSyncDescargado: boolean;
  showError: (msg: string) => void;
  saveEvents: () => Promise<void>;
}

const PlanillaDigitalUndo = ({ form, saveEvents, ...props }: IPlanillaDigitalUndo) => {
  const planillaEventosInput = useCustomInput(() => form.getPlanillaEventoInput(), [form]);

  const undoLastEvent = async () => {
    const _planillaEventos = [...planillaEventosInput.getValue()] as EventoXPlanilla[];

    const eventRemoved = _planillaEventos
      .filter((exp) => exp.getActivo())
      .sort((exp1, exp2) =>
        +exp1.getMinuto().split(':')[0] * 60 + +exp1.getMinuto().split(':')[1] >
        +exp2.getMinuto().split(':')[0] * 60 + +exp2.getMinuto().split(':')[1]
          ? -1
          : 1
      )[0];
    if (eventRemoved) {
      eventRemoved.undo();
    }
    planillaEventosInput.setValue(_planillaEventos);
    saveEvents();
  };

  const containerStyle = useContainerStyle();
  return (
    <div>
      <div className="" style={{ ...containerStyle, paddingTop: 10, paddingBottom: 10 }}>
        <div className="ms-Grid-row mb-1">
          <DefaultButton
            text="Deshacer último"
            onClick={undoLastEvent}
            allowDisabledFocus
            disabled={props.archivoSyncDescargado}
          />
        </div>
      </div>
    </div>
  );
};

export default PlanillaDigitalUndo;
